import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedUseNewFolder = mutatorAction('updateAdvancedUseNewFolder', function (useNewFolder) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.useNewFolder = useNewFolder;
});
//# sourceMappingURL=updateAdvancedUseNewFolder.js.map